import React, { PropsWithChildren } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'

interface StatusBannerProps {
  variant?: 'success' | 'warning' | 'error'
  className?: string
}

export default function StatusBanner({
  variant = 'success',
  className,
  children,
}: PropsWithChildren<StatusBannerProps>) {
  const classes = useStyles({ variant })

  return <div className={clsx(classes.statusBanner, className)}>{children}</div>
}

const useStyles = makeStyles<Theme, { variant: string }>((theme) => ({
  statusBanner: {
    padding: '12px 16px',
    borderLeft: ({ variant }) => `4px solid ${theme.components.alert[variant].border}`,
    backgroundColor: ({ variant }) => theme.components.alert[variant].background,
    borderRadius: 4,
    fontSize: '14px',
    lineHeight: '1.4',
    wordBreak: 'break-word',
  },
}))
